import React, { useContext, useEffect, useState } from 'react';
import PageTitle from '../../Components/PageTitle';
import { ConfigContext } from '../../Context/ConfigContext';
import axios from 'axios';
import { monthData } from '../../Constants/constants';
import { formatDate } from '../../Components/InputElements';
const EmploymentInformation = ({employeeMentData}) => {
    const { apiURL, apiHeaderJSON, employee_id } = useContext(ConfigContext);
    const [loading, setLoading] = useState(false);

  

    useEffect(() => {
        // getUser();
    }, []);

  return(
    <div className="card-body p-md-4 p-0">
        <div><h5>Employment Information</h5></div>
        <div className="tab-content">
            <div className="tab-pane active show" id="personalDetails" role="tabpanel">
                    <form action="javascript:void(0);">
                                <div className="row">
                                <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="firstnameInput" className="form-label">Employee Code</label>
                                                <input value={employeeMentData?.employee_code || "--"} type="text" className="form-control" id="firstnameInput"  />
                                            </div>                       
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="phonenumberInput" className="form-label">Biometric Code</label>
                                                <input value={employeeMentData?.biometric_code || "--"} type="text" className="form-control" id="phonenumberInput"/>
                                        </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="JoiningdatInput" className="form-label">Date Of Joining</label>
                                            <div className='form-control flatpickr-input'>
                                                {employeeMentData?.employee_joining_date ? formatDate(employeeMentData?.employee_joining_date ):"--"}
                                            </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="firstnameInput" className="form-label">Official Email</label>
                                                <input value={employeeMentData?.employee_official_email || "--"} type="text" className="form-control" id="firstnameInput"  />
                                        </div>
                                            </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="firstnameInput" className="form-label">Designation</label>
                                                <input value={employeeMentData?.designation_title || "--"} type="text" className="form-control" id="firstnameInput" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="firstnameInput" className="form-label">Department</label>
                                                <input value={employeeMentData?.department_title || "--"} type="text" className="form-control" id="firstnameInput"  />
                                        </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="firstnameInput" className="form-label">Location</label>
                                                <input value={employeeMentData?.location_title || "--"} type="text" className="form-control" id="firstnameInput"  />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="firstnameInput" className="form-label">Reporting Manager</label>
                                                <input value={employeeMentData?.reporting_manager_name && employeeMentData?.reporting_manager_code 
                                                ? `${employeeMentData.reporting_manager_name} (${employeeMentData.reporting_manager_code})` : "--"} 
                                                type="text" className="form-control" id="firstnameInput" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="firstnameInput" className="form-label">Probation Period</label>
                                                    <input value={employeeMentData?.probation_period || "--"} type="text" className="form-control" id="firstnameInput" />
                                            </div>
                                        </div>
                                        {/* <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="firstnameInput" className="form-label">Is Contract Yes/No</label>
                                                <input value={employeeMentData?.contract_from_date || "--"} type="text" className="form-control" id="firstnameInput"  />
                                            </div>
                                        </div> */}
                                        {/* <div className='row'> */}
                                        
                                        
                                        {employeeMentData?.is_contract_employee && employeeMentData?.contract_from_date && employeeMentData?.contract_to_date ? (
                                        
                                                <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                    <label htmlFor="contractFromDate" className="form-label">Contract From Date</label>
                                                    <input 
                                                        value={employeeMentData.contract_from_date} 
                                                        type="text" 
                                                        className="form-control" 
                                                        id="contractFromDate"
                                                    />
                                                    </div>
                                                    <div className="col-md-6">
                                                    <label htmlFor="contractToDate" className="form-label">Contract To Date</label>
                                                    <input 
                                                        value={employeeMentData.contract_to_date} 
                                                        type="text" 
                                                        className="form-control" 
                                                        id="contractToDate"
                                                    />
                                                    </div>
                                                </div>
                                                </div>
                                        
                                        ) : null}

                                        
                                    

                                        {/* </div> */}
                                                        
                                    
                                    
                                    
                                        

                                        
                                                            {/*end col*/}
                                        {/* <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="emailInput" className="form-label"> Approval Levels</label>
                                                <input value={employeeMentData?.reporting_manager_id || "--" && employeeMentData?.reporting_manager_id_level2 || "--" ? 2:1 } type="email" className="form-control" id="emailInput" />
                                            </div>
                                        </div> */}
                                                            {/*end col*/}
                                    
                                                
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="designationInput" className="form-label">Retirement Age</label>
                                                <input value={employeeMentData?.retirement_age || "--"} type="text" className="form-control" id="designationInput" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="designationInput" className="form-label">Date of Retirement</label>
                                                <input value={employeeMentData?.date_of_retirement || "--"} type="text" className="form-control" id="designationInput" />
                                            </div>
                                        </div>                           
                        </div>                             
                    </form>
            </div>                                                                       
        </div>
    </div>                              
  );
}

export default EmploymentInformation